export default "__VITE_ASSET__Cod1e61j__"